import AboutTable from '@/templates/about-table/AboutTable'
import React, { FC } from 'react'
import Footer from '../footer/Footer'
import Header from '../Home/header/Header'
import MailingComp from '../Home/mailing-comp/MailingComp'
import { CookiePageData } from './cookie-page.data'
import style from '../terms/Terms.module.scss'
import {Link} from "react-router-dom";

const CookiePage:FC = () => {
	return (
		<>
			<div className='bg-gray-wrapper'>
				<Header />
			</div>
			<div className='row tab_row'>
				<div className='col-12' style={{paddingRight: "10.5px", paddingLeft: "10.5px"}}>
					<div className={style.content}>
				<h1>SIA “iSYTC” sīkdatņu izmantošanas politika</h1>
				<div className={style.table}>
					<AboutTable>
						<h2>
							<p>1</p>
							I. KAS IR SĪKDATNES?
						</h2>
						<div className={style.content_tab}>
							<ol>
								<li>
									ir mazas teksta datnes, kuras tīmekļa pārlūkprogramma, piemēram, Mozilla Firefox, Google Chrome, Internet Explorer u.c., saglabā lietotāja iekārtā (dators, mobilais tālrunis, u.c.) brīdī, kad lietotājs apmeklē tīmekļa vietni, lai identificētu pārlūkprogrammu vai pārlūkprogrammā saglabātu informāciju vai iestatījumus.
								</li>
								<li>
									Ar sīkdatņu palīdzību tīmekļa vietne iegūst spēju saglabāt lietotāja individuālos iestatījumus, atpazīt lietotāju un atbilstoši reaģēt, lai uzlabotu tīmekļa vietnes lietošanu. Lietotājs var atspējot vai ierobežot sīkdatņu izmantošanu, tomēr bez tām tīmekļa vietnes pilnvērtīga lietošana var būt neiespējama
								</li>
							</ol>
						</div>
						<h2>
							<p>1</p>
							<div style={{padding: "0"}}>
								II. KĀDA VEIDA SĪKDATNES IZMANTO <Link to={'/'} className={style.link}>WWW.MANDARINA.LV</Link>?
							</div>
						</h2>
						<div className={style.content_tab}>
							<ol>
								<li>Obligātās sīkdatnes Būtiskas sīkdatnes, ar kuru palīdzību lietotājs var apskatīt interneta vietni un izmantot tās funkcijas, tai skaitā iegūt informāciju par piedāvāto pakalpojumu un iegādāties to. Šīs sīkdatnes identificē lietotāja iekārtu, taču neizpauž lietotāja identitāti, kā arī nevāc un neapkopo informāciju. Bez šīm sīkdatnēm tīmekļa vietne nevarēs pilnvērtīgi darboties, piemēram, sniegt lietotājam nepieciešamo informāciju, nodrošināt pieprasītos pakalpojumus vai pakalpojuma pieteikšanu.</li>
								<li>Darbības uzlabošanas sīkdatnes Sīkdatnes vāc informāciju par to, kā lietotājs izmanto interneta vietni, piemēram, kuras lapas lietotājs visbiežāk apmeklē un vai lietotājs saņem kļūdu paziņojumus. Sīkdatnes nevāc lietotāja identifikācijas datus; visa informācija ir anonīma. Tās tiek izmantotas vienīgi timekļa vietnes darbības uzlabošanai.</li>
								<li>Funkcionālās sīkdatnes Ar funkcionālajām sīkdatnēm tīmekļa vietne atceras lietotāja izvēlētos uzstādījumus un veiktās izvēles, lai lietotājs varētu ērtāk lietot vietni.</li>
								<li>Mērķētās sīkdatnes Šīs sīkdatnes nodrošina reklāmas un paziņojumus, kas saistīti ar lietotāju un lietotāja interesēm. Reizēm mērķētās sīkdatnes ir saistītas ar citām interneta vietnēm, piemēram, “Facebook”, ja šajās vietnēs lietotājs piekritis šo sīkdatņu izmantošanai, piemēram, atzīmējot “patīk” kādai lapai, kā arī saskaņā ar sīkdatņu izmantošanas politiku šajās vietnēs.</li>
								<li>Analītiskās sīkdatnes Analītiskās sīkdatnes apkopo informāciju par to, kā lietotājs lieto tīmekļa vietni, konstatē biežāk apmeklētās sadaļas, ieskaitot saturu, kuru lietotājs izvēlas, pārlūkojot vietni. Informācija tiek lietota analīzes nolūkos, lai noskaidrotu, kas interesē vietnes lietotājus un varētu uzlabot vietnes funkcionalitāti, padarot to ērtāk lietojamu. Analītiskās sīkdatnes identificē tikai lietotāja iekārtu, taču neizpauž lietotāja identitāti. Atsevišķos gadījumos dažas no analītiskajām sīkdatnēm vietnes īpašnieka vietā, saskaņā ar tā norādījumiem un tikai atbilstoši norādītajiem mērķiem, pārvalda trešās personas - datu apstrādātāji (operatori), piemēram, Google Adwords.</li>
							</ol>
						</div>
					</AboutTable>
				</div>
			</div>
				</div>
			</div>
			<MailingComp />
			<Footer />
		</>
	)
}

export default CookiePage
